

<div class="header-area flex items-center justify-end gap-2 bg-white p-4 dark:bg-[#0a0e19]">
<!--     <widget-language-switcher></widget-language-switcher>
    <widget-theme-switcher></widget-theme-switcher> -->
</div>

<div class="h-screen overflow-x-hidden bg-white py-[30px] dark:bg-[#0a0e19]">
    <div class="table h-full w-full">
        <div class="table-cell align-middle">
            <div class="mx-auto max-w-[960px] text-center">
                <img src="/cdn/assets/common/error-page/page_401.png" class="inline-block h-[400px] w-[400px]" alt="error-image">
                <h4 class="mt-[25px] !mb-[13px] !text-[19px] md:!text-[21px] md:mt-[33px]">
                    {{ 'i18n.common.error-page.page-401.title' | translate }}
                </h4>
                <p>
                    {{ 'i18n.common.error-page.page-401.subtitle' | translate }}
                </p>
            </div>
        </div>
    </div>
</div>
